/** Kayıt tablosunun adres çubuğu parametreleri (tarih filtresinden bağımsız). */
export const RECORD_PARAMS = {
  /** Durum kartlarından gelir (tek giriş yolu). */
  status: 'status',
  search: 'search',
  /** Başlık hunisi filtreleri; raporların `cf`'si ile karışmasın diye ayrı ad. */
  columns: 'rcf',
} as const

/** Sayfanın tamamını kapsayan filtreler (üst çubuk; kartlar, tonaj ve sekmeler buna göre). */
export const PAGE_PARAMS = {
  kantar: 'kantar',
  timeFrom: 'time_from',
  timeTo: 'time_to',
} as const

export const PAGE_PARAM_KEYS: readonly string[] = Object.values(PAGE_PARAMS)
